var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralFeatureEvaluationNone = function SvgGeneralFeatureEvaluationNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    fillRule: "evenodd",
    d: "m12.694 2.431 2.826 5.725 6.317.918a.774.774 0 0 1 .429 1.32l-4.57 4.456 1.077 6.292a.773.773 0 0 1-1.122.815L12 18.987l-5.65 2.97a.773.773 0 0 1-1.123-.815l1.078-6.292-4.57-4.457a.773.773 0 0 1 .428-1.319l6.317-.918 2.827-5.725a.773.773 0 0 1 1.387 0",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralFeatureEvaluationNone;